import React from 'react'
class PhotoGallery extends React.Component
{
constructor(props)
{
    super(props)
    this.state={
        show:'all'
    }
}
filterSelection1(e){
alert('')
//this.setState({show:val})
}  
handleClick=(e)=>{
    alert(e.target.value)
    this.setState({show:e.target.value})
}  
render()
{
    return(
        <>


<div id="myBtnContainer">
  <button className="btn active" value='all' onClick={this.handleClick} > Show all</button>
  <button className="btn"  value='nature' onClick={this.handleClick}> Nature</button>
  <button className="btn"  value='cars' onClick={this.handleClick}> Cars</button>
  <button className="btn"  value='people'  onClick={this.handleClick}> People</button>
</div>

<div className='row'>
<div  className={`column nature ${this.state.show=='nature' || this.state.show=='all' ? "show" : ""}`}>
<div className='content'>    
<p>N</p>
</div>
</div>
<div   className={`column nature ${this.state.show=='nature' || this.state.show=='all' ? "show" : ""}`}>
<div className='content'>    
<p>N</p>
</div>
</div>

<div   className={`column people  ${this.state.show=='people' || this.state.show=='all' ? "show" : ""}`}>
<div className='content'>    
<p>P</p>
</div>
</div>
<div    className={`column people  ${this.state.show=='people' || this.state.show=='all' ? "show" : ""}`}>
<div className='content'>    
<p>P</p>
</div>
</div>

<div  className={`column cars  ${this.state.show==='cars' || this.state.show==='all' ? "show" : ""}`}>
<div className='content'>    
<p>C</p>
</div>
</div>
<div className={`column cars  ${this.state.show==='cars' || this.state.show==='all' ? "show" : ""}`}>
<div className='content'>    
<p>C</p>
</div>
</div>

</div>


    </>
    )
}

}
export default PhotoGallery